export default{
    state: {
        snackbar: {
            open: false,
            color: null,
            text: null
        }
    },

    mutations: {
        toggleSnackbar(state, snackbar){
            state.snackbar = {...snackbar}
        }
    }
}